import React from "react";
import img from "../images/Web-developer.svg";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";

const Intro = () => {
  return (
    <>
      {/* <Helmet>
        <title>TeqnoDux | Innovative and Creative Solutions</title>
        <meta
          name="description"
          content="TeqnoDux specializes in delivering innovative and creative solutions for total communication and information challenges."
        />
        <meta
          property="og:title"
          content="TeqnoDux | Innovative and Creative Solutions"
        />
        <meta
          property="og:description"
          content="TeqnoDux specializes in delivering innovative and creative solutions for total communication and information challenges."
        />
        <meta property="og:image" content={img} />
      </Helmet> */}
      <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="about">
        <div
          className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
          data-aos="fade-up"
        >
          <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
            <img alt="card img" className="rounded-t float-right" src={img} />
          </div>
          <div
            className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8"
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            <h3 className="text-2xl sm:text-[26px] text-[#377c7d] font-bold">
              At TeqnoDux, we develop innovative and creative products and
              services that provide total communication and information
              solutions.
            </h3>
            <div>
              <p className="my-3 text-base sm:text-lg text-gray-600 font-normal">
                We are team of skilled software developers who are totally
                focused on delivering high quality software solutions which
                enable our customers to achieve their critical IT objectives.
              </p>
            </div>

            <div>
              <p className="my-3 text-base sm:text-lg text-gray-600 font-normal">
                Our commitment to excellence, combined with a customer-centric
                approach, ensures that we not only meet but exceed the
                expectations of our clients, empowering them to stay ahead in a
                competitive digital landscape.
              </p>
            </div>
            <HashLink
              to="/contact#contact"
              className="text-white bg-[#377c7d] hover:bg-[#2b6262]
 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group"
            >
              Contact us
              <svg
                className="w-4 h-4 ml-1 group-hover: translate-x-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </HashLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;
